<app-dialog
    headerText="Save View"
    saveText="SAVE"
    cancelText="CANCEL"
    headerGlyph="save"
    [body]="dialogBody"
    [validationFn]="isValid.bind(this)"
    (save)="onSave()">
</app-dialog>

<ng-template #dialogBody>
    <div class="save-view-content">
        <p i18n="XMSG|Save filter view description@@advancedSearch.saveView.description">
            Save the current filters and table configuration as a named view for quick access later.
        </p>

        <div class="form-group">
            <label class="fd-form-label is-required">
                <span i18n="XFLD|View name field label@@advancedSearch.saveView.nameLabel">View Name</span><span class="required-indicator">*</span>
            </label>
            <input
                fd-form-control
                type="text"
                class="workspace-input-field"
                [class.is-error]="errorMessage"
                [state]="errorMessage ? 'error' : 'default'"
                [(ngModel)]="viewName"
                (ngModelChange)="onInputChange()"
                placeholder="Enter a name"
                i18n-placeholder="XFLD|View name placeholder@@advancedSearch.saveView.namePlaceholder"
                maxlength="50"
                autofocus
            />
            <fd-form-message type="error" *ngIf="errorMessage">
                {{ errorMessage }}
            </fd-form-message>
        </div>

        <div class="default-checkbox">
            <fd-checkbox
                [(ngModel)]="setAsDefault"
                i18n-label="XFLD|Set as default checkbox@@advancedSearch.saveView.setAsDefault">
                Set as default
            </fd-checkbox>
        </div>
    </div>
</ng-template>

